import { Navigate } from "react-router-dom";
import { useAuthStore } from "./useAuthStore";
import { JSX } from "react";

export default function PrivateRoute({ children }: { children: JSX.Element }) {
  const token = useAuthStore((s: any) => s.token);
  console.log("Token : ", token);
  return token ? children : <Navigate to="/login" />;
}
